<template>
  <div class="campaign-child">
    <Questionnaire v-if="event.questionnaire && event.questionnaire.length > 0" :id="event.questionnaire[0]"></Questionnaire>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Questionnaire from '@/components/Voting/Questionnaire.vue'

export default {
  name: 'EventVoting',
  components: { Questionnaire },
  computed: mapGetters(['event'])
}
</script>
